import * as API from '@/api';
import DEFINES from '@/defines';

//initial state
function initialState () {
  return {
    subscription: null, /* Subscription created at Stripe end */
    localSubscription:null, /* Subscription created at our end */
    paymentMethod: null,
    invoices: null
  };
}
const state = initialState ();

// actions
const actions = {
  async create (context, payload) {
    var response = await API.subscription.create (payload);
    context.commit ('set_data', response);
    return response;
  },
  async get (context, payload) {
    var response = await API.subscription.get(payload);
    context.commit ('set_data', response);
    return response;
  },
  async cancel (context, payload) {
    var response = await API.subscription.cancel (payload);
    context.commit ('set_data', response);
    return response;
  },
  async resume (context, payload) {
    var response = await API.subscription.resume (payload);
    context.commit ('set_data', response);
    return response;
  },
  async update_payment_pethod (context, payload) {
    var response = await API.subscription.updatePaymentMethod (payload);
    context.commit ('set_data', response);
    return response;
  },
  async setSelectedPlan (context, payload) {
    try {
      await context.commit ('set_selected_plan', {
        plan: payload.plan,
      });
    } catch (error) {
      console.error ('While setting selected plan\n' + error);
    }
  },
};

//getters
const getters = {
  getSelectedPlan: state => {
    return state.selected_plan;
  }
};

// mutations
const mutations = {
  set_selected_plan (state, payload) {
    state.selected_plan = payload.plan;
  },

  set_subscription: (state, payload) => {
    state.subscription = payload.subscription;
  },

  set_data: (state, payload) => {
    state.subscription = payload.subscription;
    state.localSubscription = payload.localSubscription;
    state.paymentMethod = payload.paymentMethod;
    state.invoices = payload.invoices;
  },
  reset (state) {
    // acquire initial state
    const s = initialState ();
    Object.keys (s).forEach (key => {
      state[key] = s[key];
    });
  },
  reset_data (state) {
    state.subscription = null;
    state.paymentMethod = null;
    state.invoices = null;
    state.usage = null;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
